import React from 'react';
import { DropdownMenu } from '../DropdownMenu/DropdownMenu';
import { PARK_PORTFOLIO_KEY } from 'common/constants';
import { Box } from '@chakra-ui/react';
import { useRematchSelector } from 'models/rematchStore';
import { useNavigate, useLocation } from 'react-router-dom';
import { constructNewPathname } from 'common/state.helper';
import { Logger } from 'common/logger';

export const ParkSelectView = () => {
    const navigate = useNavigate();
    const { pathName } = useLocation();
    const rootState = useRematchSelector((state) => state);
    const { selectedPark, parkList } = rootState.appData;
    const { allowedScreens } = rootState.account;

    const portfolioKey = PARK_PORTFOLIO_KEY.toLowerCase();
    const allowedParkIds = Object.keys(allowedScreens);

    // Filter parks based on allowed screens and other criteria
    const filteredParks = parkList.filter(
        (p) => allowedParkIds.includes(p.key.toLowerCase()) && !p.shownInOperations && p.key !== portfolioKey
    );

    // Find the selected park based on the selectedParkName in the state
    const selectedParkItem = filteredParks.find((p) => p.value === selectedPark) || {};

    // Triggers on the selecting Park from the header dropdown
    const handleChange = (park) => () => {
        Logger.info(`Changing park to ${park.value}`);

        let { selectedScreen } = rootState.appData;
        const selectedParkName = park.value;
        const availableScreens = rootState.account.allowedScreens[selectedParkName.toLowerCase()];

        if (availableScreens.indexOf(selectedScreen.toLowerCase()) === -1) {
            [selectedScreen] = availableScreens;
        }
        navigate(constructNewPathname(selectedParkName, selectedScreen, pathName));
    };

    if (!selectedPark || !filteredParks.length) {
        // Render nothing if the condition is met
        return null;
    }
    return (
        <DropdownMenu
            label={
                selectedParkItem?.text?.toLowerCase() === PARK_PORTFOLIO_KEY.toLowerCase() ? (
                    <Box width="30px" />
                ) : (
                    'Park'
                )
            }
            handleChange={handleChange}
            selectedItem={selectedParkItem}
            items={filteredParks}
        />
    );
};
